// extracted by mini-css-extract-plugin
export default {"activityDate":"RecentActivityRow_activityDate__-SsqO","activitySummary":"RecentActivityRow_activitySummary__ZteTv"};